// assets/nd-quote-draft.js
// Neuma Quotes – Save Draft (final stable version, capture-only handler)
// ★ Shipping + Factor + Special Instruction 全部寫入 cart.attributes
// ★ Save Draft 的 click 完全由本檔在「捕獲階段」接管，不會再誤觸 Final / Export
// ★ 新增：按 Save Draft 會先跳出命名視窗，把 draft_name 傳給 GAS / Sheet

(function () {
  if (window.__ND_QUOTE_DRAFT_VFINAL_CAPTURE__) return;
  window.__ND_QUOTE_DRAFT_VFINAL_CAPTURE__ = true;
  console.info('[ND Quote] Draft module (FULL FINAL CAPTURE, with draft_name) loaded');

  /* ---------------- Pretty "Draft saved" modal ---------------- */
  function showDraftSavedModal() {
    try {
      var prevOverflow = document.body.style.overflow || '';

      var overlay = document.createElement('div');
      overlay.id = 'nd-draft-saved-overlay';
      overlay.style.position = 'fixed';
      overlay.style.top = '0';
      overlay.style.left = '0';
      overlay.style.width = '100%';
      overlay.style.height = '100%';
      overlay.style.zIndex = '9999';
      overlay.style.background = 'rgba(0,0,0,0.35)';
      overlay.style.display = 'flex';
      overlay.style.alignItems = 'center';
      overlay.style.justifyContent = 'center';
      overlay.style.padding = '16px';
      overlay.style.boxSizing = 'border-box';

      var dialog = document.createElement('div');
      dialog.style.maxWidth = '440px';
      dialog.style.width = '100%';
      dialog.style.background = '#ffffff';
      dialog.style.borderRadius = '14px';
      dialog.style.boxShadow = '0 18px 40px rgba(15,23,42,0.35)';
      dialog.style.padding = '20px 22px 18px';
      dialog.style.boxSizing = 'border-box';
      dialog.style.fontFamily = 'system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif';
      dialog.style.color = '#111827';
      dialog.style.position = 'relative';

      var label = document.createElement('div');
      label.textContent = 'SUCCESS';
      label.style.fontSize = '11px';
      label.style.letterSpacing = '0.08em';
      label.style.textTransform = 'uppercase';
      label.style.fontWeight = '600';
      label.style.color = '#059669';
      label.style.marginBottom = '6px';
      dialog.appendChild(label);

      var title = document.createElement('div');
      title.textContent = 'Draft saved';
      title.style.fontSize = '18px';
      title.style.fontWeight = '600';
      title.style.marginBottom = '6px';
      dialog.appendChild(title);

      var body = document.createElement('div');
      body.style.fontSize = '14px';
      body.style.lineHeight = '1.6';
      body.style.color = '#374151';
      body.style.marginBottom = '14px';
      body.innerHTML =
        'Draft has been saved successfully.<br>' +
        'You can review and load it again from account quote/draft history.';
      dialog.appendChild(body);

      var btnRow = document.createElement('div');
      btnRow.style.display = 'flex';
      btnRow.style.justifyContent = 'flex-end';
      btnRow.style.gap = '8px';
      btnRow.style.marginTop = '4px';

      var btnOk = document.createElement('button');
      btnOk.type = 'button';
      btnOk.textContent = 'OK';
      btnOk.style.padding = '7px 16px';
      btnOk.style.fontSize = '13px';
      btnOk.style.borderRadius = '9999px';
      btnOk.style.border = 'none';
      btnOk.style.background = '#111827';
      btnOk.style.color = '#FFFFFF';
      btnOk.style.cursor = 'pointer';
      btnOk.style.fontWeight = '500';

      btnRow.appendChild(btnOk);
      dialog.appendChild(btnRow);

      overlay.appendChild(dialog);
      document.body.appendChild(overlay);
      document.body.style.overflow = 'hidden';

      function closeModal() {
        document.body.style.overflow = prevOverflow;
        if (overlay && overlay.parentNode) {
          overlay.parentNode.removeChild(overlay);
        }
      }

      btnOk.addEventListener('click', closeModal);

      overlay.addEventListener('click', function (e) {
        if (e.target === overlay) {
          closeModal();
        }
      });

      document.addEventListener('keydown', function escListener(e) {
        if (e.key === 'Escape') {
          closeModal();
          document.removeEventListener('keydown', escListener);
        }
      });

      setTimeout(function () {
        btnOk.focus();
      }, 50);
    } catch (e) {
      // fallback
      alert('Draft saved.');
    }
  }

  /* ---------------- "Name your draft" modal ---------------- */
  function showDraftNameModal(defaultName, onConfirm) {
    try {
      if (typeof onConfirm !== 'function') return;

      // 若已經有開過，就不要再開第二個
      if (document.getElementById('nd-draft-name-overlay')) {
        return;
      }

      var prevOverflow = document.body.style.overflow || '';

      var overlay = document.createElement('div');
      overlay.id = 'nd-draft-name-overlay';
      overlay.style.position = 'fixed';
      overlay.style.top = '0';
      overlay.style.left = '0';
      overlay.style.width = '100%';
      overlay.style.height = '100%';
      overlay.style.zIndex = '9999';
      overlay.style.background = 'rgba(0,0,0,0.35)';
      overlay.style.display = 'flex';
      overlay.style.alignItems = 'center';
      overlay.style.justifyContent = 'center';
      overlay.style.padding = '16px';
      overlay.style.boxSizing = 'border-box';

      var dialog = document.createElement('div');
      dialog.style.maxWidth = '440px';
      dialog.style.width = '100%';
      dialog.style.background = '#ffffff';
      dialog.style.borderRadius = '14px';
      dialog.style.boxShadow = '0 18px 40px rgba(15,23,42,0.35)';
      dialog.style.padding = '20px 22px 18px';
      dialog.style.boxSizing = 'border-box';
      dialog.style.fontFamily = 'system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif';
      dialog.style.color = '#111827';
      dialog.style.position = 'relative';

      var label = document.createElement('div');
      label.textContent = 'NAME DRAFT';
      label.style.fontSize = '11px';
      label.style.letterSpacing = '0.08em';
      label.style.textTransform = 'uppercase';
      label.style.fontWeight = '600';
      label.style.color = '#4b5563';
      label.style.marginBottom = '6px';
      dialog.appendChild(label);

      var title = document.createElement('div');
      title.textContent = 'Name your draft';
      title.style.fontSize = '18px';
      title.style.fontWeight = '600';
      title.style.marginBottom = '8px';
      dialog.appendChild(title);

      var desc = document.createElement('div');
      desc.textContent = 'This name will appear in your quote draft history.';
      desc.style.fontSize = '14px';
      desc.style.lineHeight = '1.5';
      desc.style.color = '#4b5563';
      desc.style.marginBottom = '12px';
      dialog.appendChild(desc);

      var input = document.createElement('input');
      input.type = 'text';
      input.value = defaultName || '';
      input.placeholder = 'e.g. Order for Project A';
      input.style.width = '100%';
      input.style.boxSizing = 'border-box';
      input.style.padding = '8px 10px';
      input.style.borderRadius = '8px';
      input.style.border = '1px solid #d1d5db';
      input.style.fontSize = '14px';
      input.style.outline = 'none';
      input.style.marginBottom = '6px';
      input.maxLength = 120;
      dialog.appendChild(input);

      var err = document.createElement('div');
      err.style.fontSize = '12px';
      err.style.color = '#b91c1c';
      err.style.minHeight = '16px';
      err.style.marginBottom = '8px';
      err.style.display = 'none';
      dialog.appendChild(err);

      var btnRow = document.createElement('div');
      btnRow.style.display = 'flex';
      btnRow.style.justifyContent = 'flex-end';
      btnRow.style.gap = '8px';
      btnRow.style.marginTop = '4px';

      var btnCancel = document.createElement('button');
      btnCancel.type = 'button';
      btnCancel.textContent = 'Cancel';
      btnCancel.style.padding = '7px 16px';
      btnCancel.style.fontSize = '13px';
      btnCancel.style.borderRadius = '9999px';
      btnCancel.style.border = '1px solid #d1d5db';
      btnCancel.style.background = '#ffffff';
      btnCancel.style.color = '#374151';
      btnCancel.style.cursor = 'pointer';

      var btnSave = document.createElement('button');
      btnSave.type = 'button';
      btnSave.textContent = 'Save';
      btnSave.style.padding = '7px 16px';
      btnSave.style.fontSize = '13px';
      btnSave.style.borderRadius = '9999px';
      btnSave.style.border = 'none';
      btnSave.style.background = '#111827';
      btnSave.style.color = '#ffffff';
      btnSave.style.cursor = 'pointer';
      btnSave.style.fontWeight = '500';

      btnRow.appendChild(btnCancel);
      btnRow.appendChild(btnSave);
      dialog.appendChild(btnRow);

      overlay.appendChild(dialog);
      document.body.appendChild(overlay);
      document.body.style.overflow = 'hidden';

      function closeModal() {
        document.body.style.overflow = prevOverflow;
        if (overlay && overlay.parentNode) {
          overlay.parentNode.removeChild(overlay);
        }
      }

      function submit() {
        var name = (input.value || '').trim();
        if (!name) {
          err.textContent = 'Draft name cannot be empty.';
          err.style.display = 'block';
          input.focus();
          return;
        }
        if (name.length > 120) {
          err.textContent = 'Draft name is too long.';
          err.style.display = 'block';
          input.focus();
          return;
        }
        closeModal();
        onConfirm(name);
      }

      btnSave.addEventListener('click', function () {
        submit();
      });

      btnCancel.addEventListener('click', function () {
        closeModal();
        // 不呼叫 onConfirm，等於取消
      });

      overlay.addEventListener('click', function (e) {
        if (e.target === overlay) {
          closeModal();
        }
      });

      document.addEventListener('keydown', function escListener(e) {
        if (e.key === 'Escape') {
          closeModal();
          document.removeEventListener('keydown', escListener);
        }
      });

      input.addEventListener('keydown', function (e) {
        if (e.key === 'Enter') {
          e.preventDefault();
          submit();
        }
      });

      setTimeout(function () {
        input.focus();
        input.select();
      }, 50);
    } catch (e) {
      // fallback：退回原生 prompt
      var name = window.prompt('Please enter draft name:', defaultName || '');
      if (name && name.trim()) {
        onConfirm(name.trim());
      }
    }
  }

  /* ---------------- Config ---------------- */
  function getConfig() {
    var el =
      document.querySelector('[data-quotes-api-url]') ||
      document.querySelector('[data-nq-api-url]') ||
      null;

    var apiUrl =
      (el && (el.getAttribute('data-quotes-api-url') || el.getAttribute('data-nq-api-url'))) ||
      window.ND_QUOTES_API_URL ||
      '';

    var apiKey =
      (el && (el.getAttribute('data-quotes-api-key') || el.getAttribute('data-nq-api-key'))) ||
      window.ND_QUOTES_API_KEY ||
      'NeumaQuote';

    var customerEmail =
      (el && (el.getAttribute('data-customer-email') || el.getAttribute('data-nq-customer-email'))) ||
      window.ND_QUOTES_CUSTOMER_EMAIL ||
      '';

    return {
      apiUrl: apiUrl,
      apiKey: apiKey,
      customerEmail: String(customerEmail || '').toLowerCase()
    };
  }

  /* ---------------- Fetch cart ---------------- */
  function fetchCart() {
    return fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) {
      return r.json();
    });
  }

  /* ---------------- Summary ---------------- */
  function buildSummary(cart) {
    var total = (cart.total_price || 0) / 100;
    var title = (cart.items && cart.items[0] && cart.items[0].product_title) || '';
    return 'Cart total $' + total.toFixed(2) + (title ? (' | 1x ' + title) : '');
  }

  function getQuotationNo() {
    return 'DRAFT-' + Date.now();
  }

  function saveSession(quotationNo, email, draftName) {
    try {
      localStorage.setItem(
        'nd_quote_draft_session',
        JSON.stringify({
          quotation_no: quotationNo,
          customer_email: email,
          draft_name: draftName || '',
          saved_at: Date.now()
        })
      );
    } catch (err) {}
  }

  /* ---------------- Collect Shipping fields ---------------- */
  function collectShippingAttributes() {
    function v(sel) {
      var el = document.querySelector(sel);
      return el ? el.value.trim() : '';
    }

    var contact = v('input[name="attributes[Shipping Contact Name]"]');
    var phone   = v('input[name="attributes[Shipping Phone]"]');
    var ref     = v('input[name="attributes[Reference Number]"]');
    var company = v('input[name="attributes[Company Name]"]');
    var addr    = v('textarea[name="attributes[Shipping Address]"]');

    // 同時寫 Shipping* 以及 Contact Name / Phone Number 這兩個別名
    // 後端 Apps Script 的 extractExtrasFromPayload_ 會吃到 Contact Name / Phone Number
    return {
      "Shipping Contact Name": contact,
      "Contact Name":          contact,   // ★ 給 GAS 當 contact_name 用
      "Shipping Phone":        phone,
      "Phone Number":          phone,     // ★ 給 GAS 當 phone_number 用
      "Reference Number":      ref,
      "Company Name":          company,
      "Shipping Address":      addr
    };
  }

  /* ---------------- Collect Factor + Special Instruction ---------------- */
  function collectExtraFields() {
    var out = {};

    var factorEl = document.querySelector('#nd-factor-input');
    if (factorEl && factorEl.value.trim()) {
      out["Factor"] = factorEl.value.trim();
    }

    var instEl = document.querySelector('#Cart-note');
    if (instEl && instEl.value.trim()) {
      out["Special Instruction"] = instEl.value.trim();
    }

    return out;
  }

  /* ---------------- Save Draft logic ---------------- */
  /* ---------------- Save Draft logic ---------------- */
function saveDraft(btn, draftName) {
  var cfg = getConfig();
  if (!cfg.apiUrl || !cfg.customerEmail) {
    alert('Draft configuration is incomplete (missing API URL or customer email).');
    return;
  }

  // 保險：如果沒有拿到名稱，給一個預設
  draftName = (draftName || '').trim();
  if (!draftName) {
    draftName = 'Draft - ' + new Date().toISOString().slice(0, 10);
  }

  if (!btn) return;
  if (btn.__busy) return;
  btn.__busy = true;

  var originalText = btn.textContent;
  btn.disabled = true;
  btn.textContent = 'Saving...';

  fetchCart()
    .then(function (cart) {
      cart.attributes = cart.attributes || {};

      // 1) Shipping fields
      var ship = collectShippingAttributes();

      // 2) Factor + Special Instruction
      var extra = collectExtraFields();

      // 3) 合併全部欄位
      var merged = Object.assign({}, ship, extra);

      Object.keys(merged).forEach(function (k) {
        if (merged[k] && merged[k].length) {
          cart.attributes[k] = merged[k];
        }
      });

      // 4) Draft Name 也放進 attributes，之後 payload_json 解析會用到
      if (draftName) {
        cart.attributes['Draft Name'] = draftName;
      }

      console.info('[ND Quote] FULL attributes sent to GAS:', cart.attributes);

      var quotationNo = getQuotationNo();
      var summary     = buildSummary(cart);
      var cartJson    = JSON.stringify(cart);

      // ★★ 關鍵：一定要把 apiKey 帶上去 ★★
      var url =
        cfg.apiUrl +
        '?action=createdraft' +
        '&customer_email=' + encodeURIComponent(cfg.customerEmail) +
        '&summary='        + encodeURIComponent(summary) +
        '&file_type=draft' +
        '&status=Draft'    +
        '&quotation_no='   + encodeURIComponent(quotationNo) +
        '&draft_name='     + encodeURIComponent(draftName) +
        '&apiKey='         + encodeURIComponent(cfg.apiKey || 'NeumaQuote');

      // 可以暫時打開這行確認 URL 真的有 apiKey
      console.info('[ND Quote] Draft URL =', url);

      return fetch(url, {
        method: 'POST',
        mode: 'no-cors',
        headers: { 'Content-Type': 'application/json' },
        body: cartJson
      }).then(function () {
        saveSession(quotationNo, cfg.customerEmail, draftName);
        btn.textContent = 'Saved Draft';

        setTimeout(function () {
          btn.disabled = false;
          btn.textContent = originalText;
          btn.__busy = false;
        }, 1000);

        showDraftSavedModal();
      });
    })
    .catch(function (err) {
      console.error(err);
      alert('Failed, please try again.');
      btn.disabled = false;
      btn.textContent = originalText;
      btn.__busy = false;
    });
}


  /* ---------------- Insert Draft Button ---------------- */
  function findPdfButton() {
    var all = document.querySelectorAll('button, a');
    var arr = Array.prototype.slice.call(all);
    var found = null;

    arr.some(function (el) {
      var txt = (el.textContent || '').trim().toLowerCase();
      if (txt.includes('export file') || txt.includes('download cart')) {
        found = el;
        return true;
      }
      return false;
    });

    return found;
  }

  function insertDraftButton() {
    var pdfBtn = findPdfButton();
    if (!pdfBtn) return;
    if (pdfBtn.__draftAdded) return;
    pdfBtn.__draftAdded = true;

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.textContent = 'Save Draft';
    btn.className = pdfBtn.className;
    btn.style.fontSize = '1.7rem';
    btn.style.marginLeft = '8px';
    btn.setAttribute('data-nd-draft-btn', '1'); // 專用標記

    pdfBtn.parentNode.insertBefore(btn, pdfBtn.nextSibling);

    console.info('[ND Quote] Draft button added');
  }

  /* ---------------- 捕獲階段：完全接管 Save Draft click ---------------- */
  document.addEventListener(
    'click',
    function (e) {
      var t = e.target && e.target.closest('[data-nd-draft-btn="1"]');
      if (!t) return;

      // 完全接管：阻斷所有其他 listener（包含 capture / bubble）
      e.preventDefault();
      e.stopPropagation();
      if (e.stopImmediatePropagation) e.stopImmediatePropagation();

      if (t.__busy) return;

      // 預設草稿名稱：Draft - yyyy-mm-dd
      var defaultName = 'Draft - ' + new Date().toISOString().slice(0, 10);

      // 先開命名視窗，使用者確認後才真正送出
      showDraftNameModal(defaultName, function (draftName) {
        if (!draftName) return; // 使用者取消
        saveDraft(t, draftName);
      });
    },
    true // ← capture = true
  );

  /* ---------------- 初始化 ---------------- */
  function init() {
    if (!getConfig().apiUrl) return;
    insertDraftButton();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
